import { useState, useEffect, createContext } from 'react';
import {
  ThemeEnum,
  ThemeState,
  ThemeProviderProps,
  GLOBAL_THEME_KEY,
  ThemeType,
  GLOBAL_DEVICE_KEY,
} from './types';
import { defaultTheme, pickersTheme, pickitTheme } from './theme';

export const initialThemeState: ThemeState = {
  actualTheme: defaultTheme,
  isMobile: false,
  themeName: ThemeEnum.default,
  changeTheme: () => null,
  changeDevice: () => null,
};

export const ThemeContext = createContext(initialThemeState);

const ThemeProvider = ({ mobile = false, theme, children }: ThemeProviderProps) => {
  const [actualTheme, setActualTheme] = useState<ThemeType>(defaultTheme);
  const [themeName, setThemeName] = useState<ThemeEnum>(ThemeEnum.default);
  const [isMobile, setIsMobile] = useState(mobile);

  const changeTheme = (newTheme: ThemeEnum) => {
    setThemeName(newTheme);
    switch (newTheme) {
      case ThemeEnum.default:
        setActualTheme(defaultTheme);
        break;
      case ThemeEnum.pickit:
        setActualTheme(pickitTheme);
        break;
      case ThemeEnum.pickers:
        setActualTheme(pickersTheme);
        break;
      default:
        setActualTheme(defaultTheme);
        break;
    }
  };

  const changeDevice = (mobileDevice: boolean) => setIsMobile(mobileDevice);

  useEffect(() => {
    const localTheme = localStorage.getItem(GLOBAL_THEME_KEY);
    const localDevice = localStorage.getItem(GLOBAL_DEVICE_KEY);

    if (localTheme) {
      changeTheme(localTheme as ThemeEnum);
    }
    changeDevice(!!localDevice);
  }, []);

  useEffect(() => {
    localStorage.setItem(GLOBAL_THEME_KEY, theme);
    changeTheme(theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem(GLOBAL_DEVICE_KEY, (mobile || false).toString());
    changeDevice(mobile);
  }, [mobile]);

  return (
    <ThemeContext.Provider value={{ themeName, isMobile, actualTheme, changeTheme, changeDevice }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
